import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import { Order } from '@/types/order';

@Component({
})

export default class OrderListAbstract extends Vue {
    @Prop({ default: () => [] }) orders!: Order
    @Prop({ default: true }) loading!: Boolean
    @Emit() repeatComplete(uniqueNumber: string) {
        return uniqueNumber
    }
    noResultsText = 'Нет результатов, удовлетворяющих параметрам поиска.'

    get noDataText() {
        return this.loading ? 'Идет поиск...' : this.noResultsText
    }
    get needFIO() {
        return !this.$route.params.cid && this.$store.state.profile.profileType === 'manager'
    }
}